import React from 'react';
import moment from 'moment-timezone';

import Icon from './Icon';
import './EventHeader.css';

const StatusPill = ({ label }) => (
  <span className="mi-status-pill">
    <span className="mi-status-pill-dot" />
    {label}
  </span>
);

const MetaChip = ({ icon, children }) => (
  <span className="mi-meta-chip">
    <Icon name={icon} />
    {children}
  </span>
);

const EventHeader = ({ confirm, timeZone }) => {
  const {
    name,
    state_label,
    start_time,
    venue_name,
    city,
    state_code,
    age_restriction,
    contact_name,
    promoter_name,
    tags = [],
  } = confirm;

  const formattedStart = start_time
    ? moment.tz(start_time, timeZone).format('ddd, MMM D, YYYY · h:mm A')
    : null;

  return (
    <header className="mi-event-header">
      <div>
        <div className="mi-event-title-row">
          <h1 className="mi-event-title">{name}</h1>
          <StatusPill label={state_label} />
        </div>

        <div className="mi-event-meta">
          {formattedStart && (
            <MetaChip icon="calendar">
              {formattedStart}
            </MetaChip>
          )}
          <MetaChip icon="building">{venue_name}</MetaChip>
          {age_restriction && (
            <MetaChip icon="id">{age_restriction}+</MetaChip>
          )}
          {city && state_code && (
            <MetaChip icon="pin">{city}, {state_code}</MetaChip>
          )}
          {contact_name && (
            <MetaChip icon="users">{contact_name}</MetaChip>
          )}
          {promoter_name && (
            <MetaChip icon="megaphone">{promoter_name}</MetaChip>
          )}
        </div>

        <div className="mi-event-tags">
          {tags.length > 0 && (
            <span className="mi-tag-group">
              Tags
              {tags.map((tag) => (
                <span key={tag} className="mi-tag mi-tag-blue">
                  <span className="mi-tag-dot" />
                  {tag}
                </span>
              ))}
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default EventHeader;
